// extracted by mini-css-extract-plugin
module.exports = {"pill":"_3RZRCwm"};